module.exports = __webpack_public_path__ + "cf015ace3bc26fe3e489da288f096b32.svg";